import Evaluador from "pages/LandingPages/Evaluador/evaluador";

export default function EvaluadorPage() {
  return <Evaluador />;
}
